import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import '../../Assets/css/formError.css';
import axios from 'axios';
import AxiosInstance from '../../Utility/axios';
import ValidationHelper from '../../Utility/helpers/validation.helper';
import { History } from '../../history';
import { Alert } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
// import { ContextCompany } from '../../Utility/context/company';

const LoginEmailPassword = () => {
  const [isShowHidepsw, setIsShowHidepsw] = useState(false);
  const [message, setMessage] = useState({});
  const [loginData, setLoginData] = useState({});
  const [show, setShow] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [, setCookie] = useCookies(['user']);
  // const {setUserDetails} = useContext(ContextCompany)

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setDisabled(true);
    setShow(true);
    let instances = axios,
      url = `https://dev.api.outinvoice.com/v1/accounts/login`;

    if (
      process.env.REACT_APP_STATUS &&
      process.env.REACT_APP_STATUS !== 'local'
    ) {
      instances = AxiosInstance;
      url = 'accounts/login';
    }
    if (Object.keys(loginData).length === 0) {
      setDisabled(false);
      setMessage({
        email: ['This field is required.'],
        password: ['This field is required!'],
      });
      return true;
    }

    if (
      Object.keys(message).length > 0 &&
      message.non_field_errors === undefined
    ) {
      setDisabled(false);
      return true;
    }

    instances
      .post(url, loginData)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.company.length > 0) {
            localStorage.setItem('email', response.data.email);
            sessionStorage.setItem('data', JSON.stringify(response.data));
            if (loginData['remember-me']) {
              setCookie('user', JSON.stringify(response.data), {
                path: '/',
                expires: new Date().setDate(new Date().getDate + 15),
              });
            }
            let companyId = response.data.company[0].id;
            AxiosInstance.defaults.headers.common[
              'Authorization'
            ] = `Bearer ${response.data.access_token}`;

            if (
              response.data.subscription !== null &&
              !response.data.subscription.is_trial
            ) {
              // setUserDetails()
              if (!response.data.subscription.is_subscribed) {
                History.push(`/${response.data.company[0].id}/your-account`);
                return;
              }
            }

            History.push(`/${companyId}/invoices`, { companyId });
          } else {
            toast.error('You dont have any registered company!');
            sessionStorage.clear();
            Cookies.remove('user');
          }
          setDisabled(false);
        }
      })
      .catch((err) => {
        if (err) {
          setMessage(err.response.data);
          setDisabled(false);
        }
      });
  };

  const onChangeHandler = (e) => {
    let { name, value, checked } = e.target;
    // validate email
    if (name === 'email') {
      let checkEmail = ValidationHelper.EmailValidation(value);
      if (!checkEmail) {
        setMessage({
          ...message,
          email: ['Email must be valid!'],
        });
      } else {
        let new_message = message;
        delete new_message.email;
        setMessage(new_message);
      }
    }

    //validate password
    if (name === 'password') {
      let checkPassword = ValidationHelper.PasssWordValidation(value);
      if (!checkPassword) {
        setMessage({
          ...message,
          password: [
            'Password must contain atleast 1 Number, 1 uppercase and 1 symbol!',
          ],
        });
      } else {
        let new_message = message;
        delete new_message.password;
        setMessage(new_message);
      }
    }

    if (name === 'remember-me') {
      setLoginData({
        ...loginData,
        [name]: checked,
      });
      return true;
    }

    setLoginData({
      ...loginData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (localStorage.getItem('email') !== null) {
      setLoginData({
        email: localStorage.getItem('email'),
      });
      localStorage.removeItem('email');
    }
  }, []);

  return (
    <form
      className='auth__form form-container'
      onSubmit={onSubmitHandler}
      noValidate
      name={loginData}
    >
      <div className='form-group'>
        <label htmlFor='email'>Email Address</label>
        <input
          type='text'
          placeholder='Enter email address'
          name='email'
          id='email'
          className={classNames('form-control', {
            'is-invalid': message.email,
          })}
          value={loginData.email ? loginData.email : ''}
          onChange={onChangeHandler}
        />
        {message.email ? (
          <div className='invalid-feedback'>{message.email.join('')}</div>
        ) : null}
      </div>
      <div className='form-group form-group-password'>
        <label htmlFor='password'>Password</label>
        <div className='form-control-wrap'>
          <div style={{ position: 'relative' }}>
            <button
              style={{ background: 'none', border: 'none' }}
              type='button'
              className={
                isShowHidepsw
                  ? 'form-icon form-icon-right passcode-switch is-hidden'
                  : 'form-icon form-icon-right passcode-switch is-shown'
              }
              onClick={() => setIsShowHidepsw((prevState) => !prevState)}
            >
              <span className='psw-visibility'></span>
            </button>
            <input
              type={isShowHidepsw ? 'text' : 'password'}
              id='password'
              name='password'
              placeholder='***********'
              className={classNames('form-control', {
                'is-invalid': message.password,
              })}
              value={loginData.password ? loginData.password : ''}
              onChange={onChangeHandler}
            />
          </div>
          {message.password ? (
            <div className='invalid-feedback'>{message.password.join('')}</div>
          ) : null}
        </div>
      </div>

      <div className='d-flex form-group' style={{ fontSize: '0.1rem' }}>
        <div className='custom-control custom-checkbox'>
          <input
            type='checkbox'
            className='custom-control-input'
            id='remember-me'
            name='remember-me'
            checked={
              loginData['remember-me'] ? loginData['remember-me'] : false
            }
            onChange={onChangeHandler}
            onKeyPress={(e) => e.key === 'Enter' && e.target.checked === true}
          />
          <label className='custom-control-label' htmlFor='remember-me'>
            Remember me
          </label>
        </div>
        <NavLink to='/forgot-password' className='form-link'>
          Forgot Password?
        </NavLink>
      </div>
      <button className='btn btn-lg btn-primary btn-block' disabled={disabled}>
        Sign In
      </button>

      {message.non_field_errors && show ? (
        <Alert
          style={{ minWidth: '370px', marginLeft: '-25px' }}
          className='mt-2'
          variant='danger'
          onClose={() => setShow(false)}
          dismissible
        >
          <p>{message.non_field_errors.join(',')}</p>
        </Alert>
      ) : null}
    </form>
  );
};

export default LoginEmailPassword;
